/**
 * CR500 Phase 5A: BackHeaderBlock
 * 
 * Renders the back-face header with merchant name and condition.
 * This mirrors the V1 DealDetailsFlip header behavior.
 */

import React from "react";
import type { DealCardBlockProps } from "@/lib/deal-cards/specV2/types";
import type { Deal } from "@/lib/types/deals";
import { getDealCardTitle, getDealCardCondition } from "@/lib/deals/dealCardDisplay";

export const BackHeaderBlock: React.FC<DealCardBlockProps<Deal>> = ({
  deal,
  block,
  context,
}) => {
  // Don't render if block is disabled
  if (!block.enabled) {
    return null;
  }

  const title = getDealCardTitle(deal);
  const condition = getDealCardCondition(deal);

  // If no title, don't render
  if (!title) {
    return null;
  }

  return (
    <div 
      className="flex-shrink-0 p-3 border-b bg-muted/30"
      data-block="back_header"
      data-block-id={block.id}
    >
      <h3 className="font-semibold text-sm truncate pr-8">
        {title}
      </h3>
      {condition && (
        <p className="text-xs text-muted-foreground truncate mt-0.5">
          {condition}
        </p>
      )}
    </div>
  );
};

export default BackHeaderBlock;
